import React, { useEffect, useState } from "react";
import {
  getFormContent,
  getSingleSurvey,
  updateFormContent,
  surveyResultPreview,
  sharePreviewLink,
  addFormContent,
} from "../../../api/services/services";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import PremiumPageLayout from "../../templates/PremiumPageLayout";
import PremiumCard from "../../molecules/PremiumCard";
import SectionHeader from "../../molecules/SectionHeader";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Snackbar,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  TextField,
  Box,
  InputAdornment
} from "@mui/material";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import Input from "../../atoms/Input";
import ContactDetailField from "../../molecules/ContactDetailField";
import { useParams } from "react-router-dom";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import ShareWithClientsModal from "../../molecules/ShareWithClients";
import ShippingInstructionsDownload from "./ClientSide/download";
import PrintComponent from "../PrintComponent";
import TextArea from "../../atoms/Textarea";
import moment from "moment";
import { sendSuperAdminVerificationForEdit } from "../PrebidAgreement/creation/service";
import SuperAdminVerifationModal from "../../molecules/SuperAdminVerifationModal";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import DescriptionIcon from '@mui/icons-material/Description';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import PublicIcon from '@mui/icons-material/Public';
import AnchorIcon from '@mui/icons-material/Anchor';

const ShippingInstructionsPage = () => {
  const { surveyId, id, flg } = useParams();
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(flg == "1" ? true : false);

  const [isLoading, setIsLoading] = useState(false);
  const [formContent, setFormContent] = useState({
    airShipment: "",
    date: "",
    shipper: "",
    consignee: "",
    notify: "",
    description: "",
    grossWeight: "",
    portOfDischarge: "",
    destinationCountry: "",
    remarks: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isShare, setIsShare] = useState(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const getSurveyPreview = () => {
    surveyResultPreview(surveyId)
      .then((response) => {
        setSurveyData(response?.data?.data?.surveyDetail);
        let values = { ...formContent };
        values.destinationCountry = ` ${response?.data?.data?.surveyDetail?.unloadPlaceCountry}`;
        values.customerName = `${response?.data?.data?.surveyDetail?.name}`;
        setFormContent(values);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        if (response?.data?.data?.status == "submitted") getSurveyPreview();
        else {
          setSurveyData(response?.data?.data);
          let values = { ...formContent };
          values.destinationCountry = ` ${response?.data?.data?.unloadPlaceCountry}`;
          values.customerName = `${response?.data?.data?.name}`;
          setFormContent(values);
        }
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const addContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: [],
      removedMediaKeys: [],
    };
    addFormContent(body)
      .then(() => {
        setSnackbarMessage(
          "Shipping Instructions has been added successfully!"
        );
        setOpenSnackbar(true);

        setTimeout(() => {
          navigate(-1);
          setIsLoading(false);
        }, 1000);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const updateContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: [],
      removedMediaKeys: [],
    };
    updateFormContent(body, formContentId)
      .then((res) => {
        setSnackbarMessage(
          "Shipping Instructions has been updated successfully!"
        );
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContent(id, surveyId)
      .then((res) => {
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (flg == "1") getSurvey();
    else getContent();
  }, []);

  const [show, setShow] = useState(false);
  const options = {
    // resolution: Resolution.HIGH,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.SMALL,
      // default is 'A4'
      format: "letter",
      // default is 'portrait'
      orientation: "portrait",
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: "image/png",
      qualityRatio: 1,
    },
    overrides: {
      pdf: {
        compress: true,
      },
    },
  };

  //
  const generatePdf = () => {
    if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }

    setShow(true);

    setTimeout(() => {
      const content = document.getElementById("content-to-convert"); // Replace with the ID of the element you want to convert to PDF

      const currentDateTime = new Date();
      const filename = `survey_${currentDateTime.toISOString()}.pdf`;

      const pdfOptions = {
        margin: 5,
        filename: filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        }, // Set the page size here
      };

      let temp = html2pdf().from(content).set(pdfOptions).outputPdf();
      temp.save(filename);

      setShow(false);
    }, 3500);
  };

  const [downloadText, setDownloadText] = useState("download");

  const getTargetElement = () => document.getElementById("content-id");

  //
  const shareWithClient = (data) => {
    let ems = [];
    let emsInd = 0;
    data.map((dt) => {
      if (dt.trim().length != 0) {
        ems[emsInd] = dt;
        emsInd++;
      }
    });

    setIsLoading(true);
    const body = {
      surveyId: surveyId,
      formId: id,
      emails: ems,
      formRoute: "shipping-instructions",
    };
    sharePreviewLink(body)
      .then(() => {
        setSnackbarMessage(
          "Shipping Instructions have been shared with the respective emails successfully!"
        );
        setOpenSnackbar(true);

        setIsLoading(false);
        setIsShare(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  const printAction = () => {
    const PAGE_HEIGHT = 1045;
    const printElement = document.getElementById("print-component");
    if (printElement) {
      printElement.classList.add("temp-class-for-height");
      const height = printElement.clientHeight;
      const numberOfPage = Math.ceil(height / PAGE_HEIGHT);
      const heightWithSingleHeader = numberOfPage * PAGE_HEIGHT;
      let requiredHeight = heightWithSingleHeader;
      if (numberOfPage > 1) {
        const headerHeight =
          printElement.getElementsByTagName("thead")?.[0]?.clientHeight;
        const footerHeight =
          printElement.getElementsByTagName("tfoot")?.[0]?.clientHeight;
        requiredHeight -= (numberOfPage - 1) * (headerHeight + footerHeight);
      }
      printElement.style.height = `${requiredHeight}px`;
      printElement.classList.remove("temp-class-for-height");
    }
    window.print();
    if (printElement) {
      printElement.style.height = `auto`;
    }
  };

  const [isVerified, setIsVerified] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const sendEditRequestToAdmin = () => {
    setIsEditLoading(true);
    sendSuperAdminVerificationForEdit()
      .then((response) => {
        setIsVerified(true);
        setIsEditLoading(false);
      })
      .catch((error) => {
        setIsVerified(false);
        setIsEditLoading(false);
      });
  };

  // Actions for the page header
  const pageActions = (
    <>
      {!isEdit ? (
        <>
           <Button
            variant="contained"
            onClick={() => sendEditRequestToAdmin()}
            disabled={isEditLoading}
            startIcon={<NoteAltIcon />}
            sx={{
              textTransform: "none",
              borderRadius: "var(--radius-md)",
              padding: "10px 24px",
              fontWeight: 700,
              backgroundColor: "var(--primary-color)",
              boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
              '&:hover': { backgroundColor: 'var(--primary-hover)' }
            }}
          >
            Edit
          </Button>
          <Button
            variant="outlined"
            onClick={() => setIsShare(true)}
            disabled={isLoading}
            sx={{
              textTransform: "none",
              borderRadius: "var(--radius-md)",
              padding: "10px 24px",
              fontWeight: 700,
              border: "1px solid var(--glass-border)",
              color: "var(--text-main)",
              '&:hover': { background: 'var(--bg-color)', borderColor: 'var(--primary-color)' }
            }}
          >
            Share
          </Button>
           <Button
            variant="contained"
            onClick={() => {
              if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }
            var tempTitle = document.title;
              document.title = `Shipping Instructions-${
                formContent?.customerName
              }-${moment(new Date()).format("DD.MM.YYYY")}`;
              window.print();
              document.title = tempTitle;
            }}
            disabled={isLoading}
            startIcon={<DescriptionIcon />}
            sx={{
              textTransform: "none",
              borderRadius: "var(--radius-md)",
              padding: "10px 24px",
              fontWeight: 700,
              backgroundColor: "var(--text-main)",
               boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
               '&:hover': { backgroundColor: '#000' }
            }}
          >
            Save PDF
          </Button>
        </>
      ) : (
        <>
          <Button
            variant="outlined"
            color="error"
            onClick={() => {
              getContent();
              setIsEdit(false);
            }}
            disabled={isLoading}
            sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
          >
            Cancel
          </Button>
           <Button
            variant="contained"
            onClick={() => {
              if (flg == "1") addContent();
              else updateContent();
            }}
            disabled={isLoading}
            sx={{
              textTransform: "none",
              borderRadius: "var(--radius-md)",
              padding: "10px 32px",
              fontWeight: 700,
              backgroundColor: "var(--primary-color)",
              boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
              '&:hover': { backgroundColor: 'var(--primary-hover)' }
            }}
          >
            Save Changes
          </Button>
        </>
      )}
    </>
  );

  return (
    <>
      <PremiumPageLayout
        title="Shipping Instructions"
        actions={pageActions}
        onBack={() => navigate(-1)}
      >
        <PremiumCard>
          <Grid container spacing={6}>
            {/* Section 1: General Info */}
            <Grid item xs={12}>
              <SectionHeader
                title="General Information"
                icon={<LocalShippingIcon />}
                iconBg="#e3f2fd"
                iconColor="#1976d2"
              />
              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  {isEdit ? (
                    <TextField
                      fullWidth
                      label="Mode of Shipment"
                      placeholder="e.g. Air, Sea"
                      variant="outlined"
                      value={formContent?.airShipment}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.airShipment = e.target.value;
                        setFormContent(values);
                      }}
                      InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#718096" } }}
                      InputProps={{
                        style: { borderRadius: "10px", backgroundColor: "#fcfdff" }
                      }}
                    />
                  ) : (
                    <Box p={2} borderRadius="12px" bgcolor="#f8fafc" border="1px solid #edf2f7">
                      <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Mode of Shipment
                      </Typography>
                      <Typography variant="body1" style={{ fontWeight: 600, color: "#2d3748", marginTop: "4px" }}>
                        {formContent?.airShipment || <span style={{color: "#a0aec0"}}>-</span>}
                      </Typography>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  {isEdit ? (
                    <TextField
                      fullWidth
                      label="Date"
                      type="date"
                      variant="outlined"
                      value={formContent?.date}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.date = e.target.value;
                        setFormContent(values);
                      }}
                      InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#718096" } }}
                      InputProps={{
                         style: { borderRadius: "10px", backgroundColor: "#fcfdff" },
                         startAdornment: (
                          <InputAdornment position="start">
                            <CalendarTodayIcon style={{ color: "#a0aec0", fontSize: "20px" }} />
                          </InputAdornment>
                         )
                      }}
                    />
                  ) : (
                     <Box p={2} borderRadius="12px" bgcolor="#f8fafc" border="1px solid #edf2f7">
                      <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Date
                      </Typography>
                      <Typography variant="body1" style={{ fontWeight: 600, color: "#2d3748", marginTop: "4px" }}>
                         {formContent?.date ? moment(formContent?.date).format("MMMM DD, YYYY") : <span style={{color: "#a0aec0"}}>-</span>}
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Grid>

            {/* Section 2: Parties */}
            <Grid item xs={12}>
               <SectionHeader
                title="Parties Involved"
                icon={<PersonIcon />}
                iconBg="#e8f5e9"
                iconColor="#2e7d32"
              />
              <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                  {isEdit ? (
                    <TextField
                      fullWidth
                      label="Shipper"
                      placeholder="Enter shipper details..."
                      variant="outlined"
                      multiline
                      rows={3}
                      value={formContent?.shipper}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.shipper = e.target.value;
                        setFormContent(values);
                      }}
                      InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#718096" } }}
                      InputProps={{ style: { borderRadius: "10px", backgroundColor: "#fcfdff" } }}
                    />
                  ) : (
                    <Box p={2} borderRadius="12px" bgcolor="#f8fafc" border="1px solid #edf2f7" height="100%">
                      <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, textTransform: "uppercase" }}>
                        Shipper
                      </Typography>
                      <Typography variant="body1" style={{ fontWeight: 500, color: "#2d3748", marginTop: "8px", whiteSpace: "pre-wrap" }}>
                        {formContent?.shipper || <span style={{color: "#a0aec0"}}>-</span>}
                      </Typography>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  {isEdit ? (
                  <TextField
                      fullWidth
                      label="Consignee"
                       placeholder="Enter consignee details..."
                      variant="outlined"
                      multiline
                      rows={3}
                      value={formContent?.consignee}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.consignee = e.target.value;
                        setFormContent(values);
                      }}
                      InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#718096" } }}
                      InputProps={{ style: { borderRadius: "10px", backgroundColor: "#fcfdff" } }}
                    />
                  ) : (
                    <Box p={2} borderRadius="12px" bgcolor="#f8fafc" border="1px solid #edf2f7" height="100%">
                     <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, textTransform: "uppercase" }}>
                        Consignee
                      </Typography>
                       <Typography variant="body1" style={{ fontWeight: 500, color: "#2d3748", marginTop: "8px", whiteSpace: "pre-wrap" }}>
                        {formContent?.consignee || <span style={{color: "#a0aec0"}}>-</span>}
                      </Typography>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  {isEdit ? (
                    <TextField
                      fullWidth
                      label="Notify"
                      placeholder="Enter notify party..."
                      variant="outlined"
                      multiline
                      rows={3}
                      value={formContent?.notify}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.notify = e.target.value;
                        setFormContent(values);
                      }}
                      InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#718096" } }}
                      InputProps={{ style: { borderRadius: "10px", backgroundColor: "#fcfdff" } }}
                    />
                  ) : (
                     <Box p={2} borderRadius="12px" bgcolor="#f8fafc" border="1px solid #edf2f7" height="100%">
                      <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, textTransform: "uppercase" }}>
                        Notify
                      </Typography>
                       <Typography variant="body1" style={{ fontWeight: 500, color: "#2d3748", marginTop: "8px", whiteSpace: "pre-wrap" }}>
                        {formContent?.notify || <span style={{color: "#a0aec0"}}>-</span>}
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Grid>

            {/* Section 3: Cargo Details */}
            <Grid item xs={12}>
               <SectionHeader
                title="Cargo Details"
                icon={<Inventory2Icon />}
                iconBg="#fff3e0"
                iconColor="#ef6c00"
              />
              <Grid container spacing={4}>
                <Grid item xs={12} md={12}>
                  {isEdit ? (
                    <TextField
                      fullWidth
                      label="Description of Goods"
                      placeholder="Detailed description..."
                      variant="outlined"
                      multiline
                      rows={4}
                      value={formContent?.description}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.description = e.target.value;
                        setFormContent(values);
                      }}
                      InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#718096" } }}
                      InputProps={{ style: { borderRadius: "10px", backgroundColor: "#fcfdff" } }}
                    />
                  ) : (
                     <Box p={2} borderRadius="12px" bgcolor="#f8fafc" border="1px solid #edf2f7">
                      <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, textTransform: "uppercase" }}>
                        Description
                      </Typography>
                       <Typography variant="body1" style={{ fontWeight: 500, color: "#2d3748", marginTop: "8px", whiteSpace: "pre-wrap" }}>
                        {formContent?.description || <span style={{color: "#a0aec0"}}>-</span>}
                      </Typography>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  {isEdit ? (
                    <TextField
                      fullWidth
                      label="Volume/Gross Weight"
                      variant="outlined"
                      value={formContent?.grossWeight}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.grossWeight = e.target.value;
                        setFormContent(values);
                      }}
                      InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#718096" } }}
                      InputProps={{ style: { borderRadius: "10px", backgroundColor: "#fcfdff" } }}
                    />
                  ) : (
                    <Box p={2} borderRadius="12px" bgcolor="#f8fafc" border="1px solid #edf2f7">
                      <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, textTransform: "uppercase" }}>
                       Volume/Gross Weight
                      </Typography>
                      <Typography variant="body1" style={{ fontWeight: 600, color: "#2d3748", marginTop: "4px" }}>
                        {formContent?.grossWeight || <span style={{color: "#a0aec0"}}>-</span>}
                      </Typography>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  {isEdit ? (
                    <TextField
                      fullWidth
                      label="Port of Discharge"
                      variant="outlined"
                      value={formContent?.portOfDischarge}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.portOfDischarge = e.target.value;
                        setFormContent(values);
                      }}
                      InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#718096" } }}
                      InputProps={{
                        style: { borderRadius: "10px", backgroundColor: "#fcfdff" },
                         startAdornment: (
                          <InputAdornment position="start">
                            <AnchorIcon style={{ color: "#a0aec0", fontSize: "20px" }} />
                          </InputAdornment>
                         )
                      }}
                    />
                  ) : (
                     <Box p={2} borderRadius="12px" bgcolor="#f8fafc" border="1px solid #edf2f7">
                       <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, textTransform: "uppercase" }}>
                       Port of Discharge
                      </Typography>
                      <Typography variant="body1" style={{ fontWeight: 600, color: "#2d3748", marginTop: "4px" }}>
                        {formContent?.portOfDischarge || <span style={{color: "#a0aec0"}}>-</span>}
                      </Typography>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} md={4}>
                  {isEdit ? (
                    <TextField
                      fullWidth
                      label="Destination Country"
                      variant="outlined"
                      value={formContent?.destinationCountry}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.destinationCountry = e.target.value;
                        setFormContent(values);
                      }}
                      InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#718096" } }}
                      InputProps={{
                        style: { borderRadius: "10px", backgroundColor: "#fcfdff" },
                         startAdornment: (
                          <InputAdornment position="start">
                            <PublicIcon style={{ color: "#a0aec0", fontSize: "20px" }} />
                          </InputAdornment>
                         )
                      }}
                    />
                  ) : (
                     <Box p={2} borderRadius="12px" bgcolor="#f8fafc" border="1px solid #edf2f7">
                       <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, textTransform: "uppercase" }}>
                       Destination Country
                      </Typography>
                      <Typography variant="body1" style={{ fontWeight: 600, color: "#2d3748", marginTop: "4px" }}>
                        {formContent?.destinationCountry || <span style={{color: "#a0aec0"}}>-</span>}
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Grid>

             {/* Section 4: Remarks */}
            <Grid item xs={12}>
               <SectionHeader
                title="Additional Notes"
                icon={<NoteAltIcon />}
                iconBg="#f3e5f5"
                iconColor="#8e24aa"
              />
               {isEdit ? (
                    <TextField
                      fullWidth
                      label="Remarks"
                      placeholder="Any additional instructions..."
                      variant="outlined"
                      multiline
                      rows={4}
                      value={formContent?.remarks}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.remarks = e.target.value;
                        setFormContent(values);
                      }}
                      InputLabelProps={{ shrink: true, style: { fontWeight: 600, color: "#718096" } }}
                      InputProps={{ style: { borderRadius: "10px", backgroundColor: "#fcfdff" } }}
                    />
                  ) : (
                     <Box p={2} borderRadius="12px" bgcolor="#f8fafc" border="1px solid #edf2f7">
                      <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600, textTransform: "uppercase" }}>
                       Remarks
                      </Typography>
                      <Typography variant="body1" style={{ fontWeight: 500, color: "#2d3748", marginTop: "8px", whiteSpace: "pre-wrap" }}>
                        {formContent?.remarks || <span style={{color: "#a0aec0"}}>-</span>}
                      </Typography>
                    </Box>
                  )}
            </Grid>
          </Grid>
        </PremiumCard>

        {/* snackbar */}
        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000} // Adjust the duration as needed
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity={
              snackbarMessage?.includes("successful") ? "success" : "error"
            }
            onClose={handleCloseSnackbar}
          >
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
        {/* /snackbar */}

        {/* share with client */}
        {isShare && (
          <ShareWithClientsModal
            open={isShare}
            onClose={() => {
              setIsShare(false);
            }}
            onSuccess={(emails) => {
              shareWithClient(emails);
            }}
          />
        )}
      </PremiumPageLayout>

      <PrintComponent>
        <ShippingInstructionsDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      {isVerified && (
        <SuperAdminVerifationModal
          open={isVerified}
          onClose={() => setIsVerified(false)}
          onSuccess={() => {
            setIsEdit(true);
            setIsVerified(false);
          }}
          onError={() => {
            setSnackbarMessage("Invalid Confirm Pin");
            setOpenSnackbar(true);
          }}
        />
      )}
    </>
  );
};
export default ShippingInstructionsPage;
